<div class="page-padding">
  <div class="panel" style="padding: 1%;">
    <div class="search-options" style="min-width: 150px; width: 100%; display: flex; gap: 25%; flex-wrap: wrap;">
      <div class="flex-row">
        <mat-form-field class="header-form-full-width">
          <span class="label">{{'Customer' | translate | async}}</span>
          <mat-select id="select-customer" [placeholder]="'Select Customer' | translate | async" [(ngModel)]="selectedCustomer"
                      (selectionChange)="loadJobsitesForCustomer()" ngDefaultControl multiple>
            <mat-option [value]="customer.Id" *ngFor="let customer of customerList">
              {{customer.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="header-form-full-width">
          <span class="label">{{'Jobsite'  | translate | async}}</span>
          <mat-select id="select-jobsite" [placeholder]="'Select Job Site' | translate | async" [(ngModel)]="selectedJobsite"
                      ngDefaultControl multiple (selectionChange)="loadFamilyOnJobsite()" >
            <mat-option [value]="jobsite.Id" *ngFor="let jobsite of jobsiteList">
              {{jobsite.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="header-form-full-width" *ngIf="api!=0">
          <span class="label">{{'Family'  | translate | async}}</span>
          <mat-select id="select-jobsite" [placeholder]="'Select Family' | translate | async" [(ngModel)]="selectedFamilies"
                      ngDefaultControl multiple (selectionChange)="loadModelForfamily()">
            <mat-option [value]="family.Id" *ngFor="let family of familyFilteredList">
              {{family.Name}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field class="header-form-full-width" *ngIf="api!=0">
          <span class="label">{{'Model'  | translate | async}}</span>
          <mat-select id="select-model" [placeholder]="'Select Model' | translate | async" [(ngModel)]="selectedModels"
                      ngDefaultControl multiple>
            <mat-option [value]="model.Id" *ngFor="let model of filterModelList">
              {{model.Title}}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div class="flex-row notification">

        <div *ngIf="isDownloading">
          <h3>JSON file is downloading…</h3>
          <p class="blink-text">Please wait...</p>
        </div>

        <div *ngIf="customerRequired" style="color: #b71c1c">
          <h3>At least one customer selection is required ⚠</h3>
        </div>

        <div *ngIf="noDataFound && !isDownloading" style="color: #b71c1c">
          <h3>No data found ⚠</h3>
        </div>

        <div *ngIf="!isDownloading && downloadStarted">
          <h3>Download Started ✅</h3>
          <p>
            Your JSON file should begin downloading automatically. Please check your <strong>Downloads</strong> folder.
          </p>
          <p>
            If the download did not start, click the JSON Download button again.
          </p>
        </div>
        <div class="search-control header-form-full-width">
          <div class="flex flex--align-center" style="display: flex; justify-content: flex-end;">
            <a class="button" (click)="ResetFields();"><span class="button__text">{{'Reset'  | translate | async}}</span></a>&nbsp;&nbsp;
            <a class="button button--primary" (click)="getJSON()" title="Click to download JSON.">
              <i class="material-icons button__icon">download</i><span class="button__text">{{'JSON'  | translate | async}}</span>
            </a>
            <a style="display:none" class="button button--primary" (click)="getCSV()" title="Click to download CSV.">
              <i class="material-icons button__icon">download</i><span class="button__text">{{'CSV Export'  | translate | async}}</span>
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
